import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/login')
    },
    {
      path: '/main',
      name: 'Main',
      component: () => import('@/views/main')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js